module.exports = __webpack_public_path__ + "static/media/yt-free-gift.2208a3ba.jpeg";